import { MCP_ENDPOINT_PATH } from '@/core/const/mcpGateway.const'

import { buildGatewayHost } from './buildGatewayHost'

/**
 * Builds the MCP HTTP URL for the gateway (e.g. http://host:port/mcp).
 * Port is resolved from the gateway /mcpport route (GATEWAY_ROUTE_MCP_PORT).
 */
export const buildMcpUrl = (path: string, port: string | undefined, isSecured?: boolean) => {
  const protocol = isSecured ? 'https' : 'http'
  const trimmedPort = port?.trim()

  return `${protocol}://${buildGatewayHost(path, trimmedPort || undefined)}/${MCP_ENDPOINT_PATH}`
}
